<template>
  <div class="container">
    <div class="shop_list">
        <scroll  :allLoaded="allLoaded"
            :data="list"
            @pulldown="loadData"
            @loadUp="loadup" >
          
          <template v-if="$store.state.common.theme!=3" >
            <div class="list_cell" v-for="(item,index) in list" :key="index"  @click="toDetail(item.id)">
                <div class="list_item">
                    <div class="list_item_top">
                        <div class="list_item_top_left">
                          <img v-if="item.noticeLabel=='园区公告'" class="list_item_top_left_icon" src="../../assets/images/icon_notice_park.png">
                          <img v-else-if="item.noticeLabel=='新闻动态'" class="list_item_top_left_icon" src="../../assets/images/icon_notice_news.png"/>
                          <img v-else class="list_item_top_left_icon" src="../../assets/images/icon_notice_weather.png"/>
                          <span class="list_item_top_left_span">{{item.noticeLabel}}</span>
                        </div>
                        <span class="list_item_top_right">{{item.createTime | formatTime}}</span>
                    </div>
                    <div class="list_item_bottom">
                      <span class="list_item_bottom_span">{{item.noticeTitle}}</span>
                    </div>
                </div>
            </div>
          </template>

          <template v-if="$store.state.common.theme ==3" >
            <div class="list_cell_theme3" v-for="(item,index) in list" :key="index"  @click="toDetail(item.id)">
                <div class="list_item_theme3">
                    <div class="list_item_top">
                        <div class="list_item_top_left">
                          <img v-if="item.noticeLabel=='园区公告'" class="list_item_top_left_icon" src="../../assets/images/icon_notice_park.png">
                          <img v-else-if="item.noticeLabel=='新闻动态'" class="list_item_top_left_icon" src="../../assets/images/icon_notice_news.png"/>
                          <img v-else class="list_item_top_left_icon" src="../../assets/images/icon_notice_weather.png"/>
                          <span class="list_item_top_left_span">{{item.noticeLabel}}</span>
                        </div>
                        <span class="list_item_top_right">{{item.createTime | formatTime}}</span>
                    </div>
                    <div class="list_item_bottom">
                      <span class="list_item_bottom_span">{{item.noticeTitle}}</span>
                    </div>
                </div>
            </div>
          </template>
        </scroll>
    </div>
    <no-message v-if="!list.length && loaded"></no-message>
 </div>
</template>

<script>
import Scroll from "../../components/scroll";
import { mapState } from 'vuex';
import NoMessage from "../../components/nomessage";
import { getNoticeListByMarketId } from "../../utils/api";
import util from '../../utils/util';

export default {
  name: "noticeList",
  components: {
     Scroll,
     NoMessage
  },
  computed: {
    ...mapState({
      common: state => state.common,
    })
  },

  filters: {

    formatTime(val){
      return util.formatTime(new Date(val),4)
      //configObj.formatTime(new Date(val),'-','yyyymmdd');
    }
  },

  data() {
    return {
      list:[],
      isLoding:false,
      allLoaded:false, //是否加载完
      pageNo:1,
      loaded:false
    }
  },

  created() {
    this.getNoticeListAction();
  },
  activated () {
    //this.getParkInfo();
    // if (this.parkId !== this.$route.params.id) {
    //   this.parkId = this.$route.params.id;
    //   this.getParkMemberAction();
    // }
  },

  methods: {
    getNoticeListAction(){
      this.isLoding=true;
      let params = {
          marketId:this.common.marketInfo.id,
          userId:this.common.userId,
          pageNo: this.pageNo,
          pageSize:10
      }

       getNoticeListByMarketId(params).then(res => {
          this.isLoding=false;
          this.loaded =true;
        if (res.res.code === 10000 && res.body) {
          console.log(res)
          if(this.pageNo==1){
            this.list = res.body.noticeList;
          } else if(res.body.noticeList.length>0){
            this.list = this.list.concat(res.body.noticeList);
          }
          if(res.body.noticeList.length != 10){
            this.allLoaded =true;
          }
        }
        });


    },
    //上拉
     loadup(){
       console.log("in loadup");
       if(this.isLoding){
         return;
       }
       if(this.allLoaded){
         return;
       }
       this.pageNo=this.pageNo+1;
       this.getNoticeListAction();
     },

     //下拉刷新
     loadData(){
       if(this.isLoding){
         return;
       }
       this.pageNo=1;
       this.allLoaded =false;
       this.getNoticeListAction();
     },

      // 公告详情
    toDetail(id) {
      this.$router.push(`/noticeDetail/${id}`);
    }

  }
}
</script>

<style lang="less" scoped>
@import "../../assets/css/common.less";
.container {
  height: 100vh;
  background-color: @colore;
}
.shop_list {
  height: 100vh;
  box-sizing: border-box;
  overflow: hidden;
}
.list_cell{
  width: 100%;
  height: 244px;
  display: flex;
  flex-direction: column;
  background-color: @colore;
}

.list_cell_theme3{
  width: 100%;
  height: 244px;
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
}

.list_item{
  margin-top: 40px;
  margin-left: 20px;
  width: 710px;
  height: 204px;
  display: flex;
  flex-direction: column;
  background-color:rgba(255,255,255,1);
  border-radius:8px;

}

.list_item_theme3{
  margin-top: 40px;
  margin-left: 20px;
  width: 710px;
  height: 204px;
  display: flex;
  flex-direction: column;
  background-color:rgba(255,255,255,1);
  border-bottom: 2px solid rgba(0,0,0,0.3);

}

.list_item_top{
  width: 710px;
  height: 76px;
  border-radius:8px 8px 0px 0px;
  background-color:#FAFAFA;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

}

.list_item_top_left{
  flex-direction: row;
  display: flex;
  margin-left: 28px;
}
.list_item_top_left_icon{
  display: flex;
  width: 44px;
  height: 44px;
}
.list_item_top_left_span{
  margin-top: 4px;
  margin-left: 20px;
  height:40px;
  font-size:28px;
  font-weight:500;
  color:rgba(51,51,51,1);
  line-height:40px;
}

.list_item_top_right{
  margin-right: 20px;
  height:34px;
  font-size:24px;
  font-weight:400;
  color:rgba(153,153,153,1);
  line-height:34px;

}


.list_item_bottom{
  width: 710px;
  height: 128px;
  display: flex;
  flex-direction: row;
  background-color:#FFFFFF;
  align-items: center;
}

.list_item_bottom_span{
  // margin-top: 28px;
  // height: 72px;
  margin-left: 28px;
  width:654px;
  font-size:26px;
  font-weight:400;
  color:rgba(51,51,51,1);
  line-height:36px;
  max-lines: 2;
  max-width: 654px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
   white-space: pre-line;


}

</style>
